import {Swiper} from '$c3base/swiper-imports.js';

let navigationWidth = 0;
let headerBanner = null;
let navBreakpoint = 0;
let headerBannerInterval;

$.fn.sameHeight = function () {
    let maxHeight = 0;
    this.each(function () {
        let height = $(this).height();
        if (height > maxHeight) {
            maxHeight = height;
        }
    });
    this.height(maxHeight);
};

if (localStorage.getItem('debug')) {
    const style = document.createElement('style');
    style.innerText = '.extbase-debugger {display: block !important}';
    document.head.append(style);
}

$(function () {
    $('.frame-layout-bg-img-black-white').parent().addClass('background');
    $('.frame-layout-standard-text-media')
        .find('.ce-gallery')
        .parent('.ce-textpic')
        .parent('.frame-type-textmedia')
        .parent()
        .addClass('pic-col');

    lazyLoadImages();
    setRowHeight();
    setMobileBgPic();
    setFrameWidthMobileSwiper();
    checkResponsiveSwipers();
    mobileNav();
    positionSwiperControls();
    desktopNav();
    fixProductSliderHeights();
    initSerialForm();
    initVideoSwiper();
    initVideoCategories();
    initSettings();
    initProductDetail();
    initProductFilters();
    initFaq();
    initNavLinks();

    if ($(window).width() < 1200) {
        $('.ce-uploads div.mobile').show();
    } else {
        $('.ce-uploads div.mobile').hide();
    }

    let prodid = $('.send-product-inquiry').attr('id');

    $('.send-product-inquiry').click(function () {
        localStorage.removeItem('prodid');
        localStorage.setItem('prodid', $(this).attr('id'));
    });
    if (('.prod-inquiry').length > 0) {
        $('.prod-inquiry > a').click(function () {
            localStorage.removeItem('prodid');
            localStorage.setItem('prodid', prodid);
        });
    }
    if ($('#powermail_field_model').length > 0) {
        if (localStorage.hasOwnProperty('prodid')) {
            $('#powermail_field_model option').removeAttr('selected');

            $('#powermail_field_model option').each(function () {
                if ($(this).val() == localStorage.getItem('prodid')) {
                    $(this).attr('selected', true);
                    localStorage.removeItem('prodid');
                }
            });
        } else {
            //$("#powermail_field_model").append("<option value='0' disabled='disabled' selected='selected'>Please choose...</option>");
        }
    }
    /**
     * header banner height
     * @type {*|jQuery.fn.init|jQuery|HTMLElement}
     */
    headerBanner = $('.header-banner');
    if (headerBanner.length) {
        headerBannerInterval = setInterval(function () {
            checkBannerHeight();
        }, 20);
    }

    const navigation = $('header .desktop nav');
    if (navigation.length) {
        navigation.find('.level_1 > li').each(function () {
            navigationWidth += $(this).outerWidth();
            let level2 = $(this).find('.level_2');
            if (level2.length && level2.outerWidth() > $(this).outerWidth()) {
                level2.css({
                    left: -((level2.outerWidth() - $(this).outerWidth()) / 2) + 'px'
                });
            }
        });
    }

    if ($('.accordion-outer-wrap').length) {
        $('.accordion-outer-wrap').each(function () {
            $(this).accordion({
                collapsible: true,
                heightStyle: 'content',
                active: 0,
                activate: function (event, ui) {
                    if (!$.isEmptyObject(ui.newHeader.offset())) {
                        ui.newHeader[0].scrollIntoView({behavior: 'smooth'});
                    }
                }
            });
        });
    }

    $('.product-swiper').each(function () {
        let outerSwiperWrap = $(this).parent();

        let confObject = {
            speed: 500,
            slidesPerView: (($(this).data('slidesperview') > null) ? $(this).data('slidesperview') : 4),
            spaceBetween: 40,
            slidesPerGroup: (($(this).data('slidesperview') > null) ? $(this).data('slidesperview') : 4),
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            watchOverflow: true,
            loop: false,
            breakpoints: {
                768: {
                    slidesPerView: (($(this).data('slidesperview768') > null) ? $(this).data('slidesperview768') : 2),
                    slidesPerGroup: (($(this).data('slidesperview768') > null) ? $(this).data('slidesperview768') : 2),
                    spaceBetween: 40,
                },
                1200: {
                    slidesPerView: (($(this).data('slidesperview1200') > null) ? $(this).data('slidesperview1200') : 3),
                    slidesPerGroup: (($(this).data('slidesperview1200') > null)
                        ? $(this).data('slidesperview1200')
                        : 2),
                    spaceBetween: 50,
                },
            }
        };

        if (outerSwiperWrap.find('.swiper-pagination').length) {
            confObject.pagination = {
                el: outerSwiperWrap.find('.swiper-pagination')[0],
                clickable: true,
            };
        }

        if (outerSwiperWrap.find('.swiper-button-next').length && outerSwiperWrap.find('.swiper-button-prev').length) {
            confObject.navigation = {
                nextEl: outerSwiperWrap.find('.swiper-button-next')[0],
                prevEl: outerSwiperWrap.find('.swiper-button-prev')[0],
            };
        }

        let temp = new Swiper($(this), confObject);
        swiperContainer.push(temp);

        temp.on('slideChange', function () {

            if (this.isBeginning) {
                $(this.el).siblings('.hr-wrap').removeClass('slide-left');
            } else {
                $(this.el).siblings('.hr-wrap').addClass('slide-left');
            }
            if (this.isEnd) {
                $(this.el).siblings('.hr-wrap').addClass('end-slide-right');
            } else {
                $(this.el).siblings('.hr-wrap').removeClass('end-slide-right');
            }

        });
        if ($(this).siblings('.swiper-pagination-lock').length > 0) {
            $(this).siblings('.hr-wrap').addClass('no-slide');
        }
    });
    $('.product-images').each(function () {
        let swiperId = $(this).data('swiperid'),
            outerSwiperWrap = $(this).parent();

        let confObject = {
            speed: 500,
            slidesPerView: 4,
            spaceBetween: 40,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            watchOverflow: true,
            loop: false,
            breakpoints: {
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                },
            }
        };

        if (outerSwiperWrap.find('.swiper-pagination').length) {
            confObject.pagination = {
                el: outerSwiperWrap.find('.swiper-pagination')[0],
                clickable: true,
            };
        }

        if (outerSwiperWrap.find('.swiper-button-next').length && outerSwiperWrap.find('.swiper-button-prev').length) {
            confObject.navigation = {
                nextEl: outerSwiperWrap.find('.swiper-button-next')[0],
                prevEl: outerSwiperWrap.find('.swiper-button-prev')[0],
            };
        }

        let temp = new Swiper($(this), confObject);
        swiperContainer.push(temp);
        temp.on('progress', function () {
            if (!this.isLocked) {
                if (this.isBeginning) {
                    $(this.el).siblings('.hr-wrap').removeClass('slide-left');
                } else {
                    $(this.el).siblings('.hr-wrap').addClass('slide-left');
                }
                if (this.isEnd) {
                    $(this.el).siblings('.hr-wrap').addClass('end-slide-right');
                } else {
                    $(this.el).siblings('.hr-wrap').removeClass('end-slide-right');
                }
            }
        });

        if ($(this).siblings('.swiper-pagination-lock').length > 0) {
            $(this).siblings('.hr-wrap').addClass('no-slide');
        }
    });

    $('#platzhalter').remove();

    $('.nav-item:first-child').addClass('active');
    $('.tab-pane:first-child').addClass('active');


    $('#powermail_field_adressline1').attr('autocomplete', 'street-address');
    $('#powermail_field_country').attr('autocomplete', 'country');


    let navTab = $('.nav-item');
    if (navTab.length) {
        navTab.click(function () {
            let tab_id = $(this).attr('data-tab');
            navTab.siblings().removeClass('active');
            $('.tab-content').find('.tab-pane').removeClass('active');
            $(this).addClass('active');
            $('#nav-c' + tab_id).addClass('active');

            let right = ($(window).width() - 20) - ($(this).offset().left + $(this).outerWidth());
            if ($(window).width() < 768) {
                let scrollLeft = '';
                if ($(this).offset().left < 20) {
                    scrollLeft = $(this).offset().left - 20;
                    $(this).parent().animate({
                        scrollLeft: '+=' + scrollLeft
                    }, 500);
                } else if (right < 0) {
                    $(this).parent().animate({
                        scrollLeft: '-=' + right
                    }, 500);
                }

            }

        });
    }

    $('.accordion-section-header').click(function () {
        let accordionId = $(this).data('accordion-id');
        let targetAccordion = $(this).parents('.accordion-section-headers')
            .siblings('.accordion-outer-wrap[data-accordion-id="' + accordionId + '"]');

        $(this).addClass('active');
        $(this).siblings()
            .removeClass('active');

        targetAccordion.removeClass('hidden');
        targetAccordion.siblings('.accordion-outer-wrap')
            .addClass('hidden');

        if (targetAccordion.length > 0) {
            targetAccordion[0].scrollIntoView({behavior: 'smooth'});
        }
    });

    if ($('.ui-accordion-content').length) {
        $('<span class="divider"></span>').insertAfter($('.ui-accordion-content'));
    } else if ($('.panel-collapse').length) {
        $('<span class="divider"></span>').insertAfter($(' .panel-collapse'));
    }
    $('.dce-artist-slider').parents('.header-banner').css('filter', 'none');

    collapseVideos();
});

$(window).on('load', function (e) {
    checkResponsiveSwipers();
});

$(window).on('resize', function (e) {
    lazyLoadImages();
    setMobileBgPic();
    setRowHeight();
    setFrameWidthMobileSwiper();
    checkBannerHeight();
    checkResponsiveSwipers();
    positionSwiperControls();

    if ($(window).width() < 1200) {
        $('.ce-uploads div.mobile').show();
    } else {
        $('.ce-uploads div.mobile').hide();
    }

});

function setFrameWidthMobileSwiper() {
    if ($('.news-list-swiper').length > 0 || $('.upload-swiper').length > 0) {
        if ($(window).width() < 600) {
            $('.news-list-swiper').parents('.frame').addClass('mobile-swiper');
            $('.upload-swiper').parents('.frame').addClass('mobile-swiper');
        } else {
            $('.upload-swiper').parents('.frame').removeClass('mobile-swiper');
            $('.news-list-swiper').parents('.frame').removeClass('mobile-swiper');
        }

    }
}

function lazyLoadImages() {
    let version = 'mobile';
    if ($(window).width() > 500) {
        version = 'tablet-vertical';
    }
    if ($(window).width() > 768) {
        version = 'tablet-horizontal';
    }
    if ($(window).width() > 1150) {
        version = 'default';
    }
    if ($(window).width() > 1920) {
        version = '2k';
    }
    $('.background .ce-image').each(function () {
        if ($(this).parents('.background').length) {
            $(this).css('background-image', 'url(' + $(this).data(version) + ')');
        }
    });
}

function setMobileBgPic() {
    $('.frame-layout-standard-text-media').each(function () {
        if (window.innerWidth < 600) {
            $(this).find('.mobile-bg').css('width', $(window).width()).css('height', $(this).height());
        } else {
            $(this).find('.mobile-bg').width(0).height(0);
        }
    });
}

function setRowHeight() {
    $('.frame-layout-standard-text-media').each(function () {
        let picHeight = '';
        if (window.innerWidth > 768) {
            picHeight = $(this).find('.ce-gallery').outerHeight();
        } else {
            let headerHeight = '';
            if ($(this).find('.frame-type-header').length > 0) {
                headerHeight = $(this).find('.frame-type-header').outerHeight();
                $(this).find('.pic-col').css('padding-top', headerHeight);
            }
            picHeight = 'auto';
        }
        let rowHeight = $(this).find('.row').outerHeight();
        if (rowHeight < picHeight) {
            $(this).find('.row').css('height', picHeight);
        } else {
            $(this).find('.row').css('height', 'auto');
        }

    });
}

function checkBannerHeight() {
    if (
        headerBanner &&
        parseInt(headerBanner.children('.banner-outer-wrap').height()) <= parseInt(headerBanner.css('height')) &&
        parseInt(headerBanner.children('.banner-outer-wrap')
            .height()) < parseInt(headerBanner.data('initial-height'))) {
        headerBanner.height('auto');
    } else if (headerBanner.length) {
        headerBanner.height(headerBanner.data('initial-height'));
        clearInterval(headerBannerInterval);
    }
}

function collapseVideos() {
    let videoArr = [];
    $('.productVideoWrap .frame').each(function () {
        let urls = [];
        $(this).find('.productVideo').each(function () {
            urls.push($(this).attr('href'));
        });

        let joined = urls.join('|');

        if (videoArr.includes(joined)) {
            $(this).hide();
        } else {
            videoArr.push(joined);
        }
    });
}

function checkResponsiveSwipers() {
    $('.responsive-swiper').each(function () {
        createResponsiveSwiper($(this));
    });
}

function createResponsiveSwiper(el) {
    const initWidth = el.data('swiper-init');
    const isInitialized = el.hasClass('initialized');
    const slidesPerView = el.data('swiper-slides-per-view');
    const responsiveConfig = el.data('swiper-responsive');

    if (window.innerWidth <= initWidth && !isInitialized) {

        const breakpoints = {};
        $.each(responsiveConfig, function (breakpoint, slides) {
            breakpoints[breakpoint] = {
                slidesPerView: slides,
            };
        });

        new Swiper(el[0], {
            slidesPerView: slidesPerView,
            loopAdditionalSlides: 500,
            watchOverflow: true,
            loop: false,
            grabCursor: true,
            breakpoints: breakpoints,
            spaceBetween: 30,
            pagination: {
                clickable: true,
                el: el.siblings('.swiper-pagination')[0]
            },
            navigation: {
                nextEl: el.siblings('.swiper-button-next')[0],
                prevEl: el.siblings('.swiper-button-prev')[0]
            }
        });

        el.addClass('initialized');
        el.find('.swiper-wrapper').wrap('<div class="swiper-overflow-wrap">');


    } else if (window.innerWidth > initWidth) {
        if (el[0].swiper) {
            el[0].swiper.destroy();
        }

        el.removeClass('initialized');
        const wrapper = el.find('.swiper-wrapper');
        wrapper.appendTo(wrapper.parents('.swiper-container'));
        wrapper.siblings('.swiper-overflow-wrap').remove();
    }
}

function mobileNav() {
    $('header .hamburger').click(function () {
        $('body').toggleClass('mobile-nav-open');
    });

    $('.open-sub').click(function () {
        $(this).siblings('.menu').addClass('open');
    });

    $('.menu-header-back').click(function () {
        $(this).parents('.menu').first().removeClass('open');
    });

    $('.menu-header-close').click(function () {
        $('body').removeClass('mobile-nav-open');
        $('header .hamburger').removeClass('is-active');
    });
}

function desktopNav() {

    const firstLevelLinks = $('.header-wrap.desktop').find('.level_1 > li > a');
    const secondLevelLinks = firstLevelLinks.parent().find('.sub-menu-items .menu-link');

    firstLevelLinks.click(function (e) {
        if (!$(this).hasClass('clicked') && $(this).parent().hasClass('is-parent')) {
            e.preventDefault();
            $(this).addClass('clicked');
            $(this).parents('.level_1')
                .find('> .menu-item > .clicked')
                .not($(this))
                .removeClass('clicked');
            const firstSub = $(this).parent()
                .find('.sub-menu-items')
                .find('.menu-link')
                .first();
            if (firstSub.hasClass('has-content') && !firstSub.hasClass('clicked')) {
                firstSub.trigger('click');
            }
        }
        $(this).parents('.header-wrap').addClass('nav-open');
        $('body').addClass('nav-open');
    });

    secondLevelLinks.click(function (e) {
        if ((!$(this).hasClass('clicked') && $(this).hasClass('has-content'))) {
            e.preventDefault();
            $(this).addClass('clicked');
            $(this).siblings()
                .removeClass('clicked');
            const navId = $(this).data('nav-id');
            const menuContent = $(this).parents('.sub-menu')
                .find('.content-wrap[data-nav-id="' + navId + '"]');
            menuContent.addClass('nav-selected')
                .siblings()
                .removeClass('nav-selected');
        }
    });

    $('.close-nav, .content-wrap:not(.has-content)').click(function () {
        $(this).parents('.menu-item')
            .find('.clicked')
            .removeClass('clicked');
        $(this).parents('.header-wrap').removeClass('nav-open');
        $('body').removeClass('nav-open');
    });

    $('.nav-product-swiper').each(function () {
        new Swiper($(this)[0], {
            slidesPerView: 1,
            spaceBetween: 200,
            grabCursor: true,
            centeredSlides: false,
            loop: false,
            navigation: {
                nextEl: $(this).siblings('.swiper-button-next')[0],
                prevEl: $(this).siblings('.swiper-button-prev')[0]
            },
            breakpoints: {
                600: {
                    slidesPerView: 'auto',
                    spaceBetween: 40
                }
            }
        });
    });
}

function fixProductSliderHeights() {
    $('.product-category-swiper').each(function () {
        $(this).find('.product-title .title').sameHeight();
    });
    $('.sub-category-swiper').each(function () {
        $(this).find('.product-title .title').sameHeight();
    });
    $('.nav-product-swiper').each(function () {
        $(this).find('.product-title .title').sameHeight();
    });
    $('.custom-product-slider').each(function () {
        $(this).find('.category-title .title').sameHeight();
    });
}

function positionSwiperControls() {
    $('.product-category-swiper').each(function () {
        let paginationHeight = $(this).siblings('.swiper-pagination').height();
        let controls = $(this).siblings('.swiper-button-prev, .swiper-button-next');
        controls.css('margin-top', -((paginationHeight - controls.height()) / 2) - (controls.height() + 2));
    });
}

function initVideoSwiper() {
    $('.videos-list-slider').each(function () {
        new Swiper($(this).find('.swiper-container')[0], {
            slidesPerView: 1,
            spaceBetween: 40,
            slidesPerGroup: 1,
            grabCursor: true,
            pagination: {
                el: $(this).find('.swiper-pagination')[0]
            },
            navigation: {
                prevEl: $(this).find('.swiper-button-prev')[0],
                nextEl: $(this).find('.swiper-button-next')[0]
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3
                }
            }
        });
    });
}

function initVideoCategories() {
    $('.tx-c3local-videos .categorized').each(function () {
        const buttons = $(this).find('.categorized-categories-button');
        const categories = $(this).find('.categorized-videos-category');

        buttons.click(function () {
            const self = $(this);
            const id = self.data('video-category-id');

            self.addClass('categorized-categories-button-selected nav-tree-selected');
            buttons.not(self)
                .removeClass('categorized-categories-button-selected nav-tree-selected');

            const targetCategory = categories.filter(`[data-category-id="${id}"]`);
            targetCategory.addClass('categorized-videos-category-selected');
            categories.not(targetCategory)
                .removeClass('categorized-videos-category-selected');
        });
    });
}

function initSettings() {
    const settingsBtn = document.querySelector('.settings-button');
    settingsBtn.addEventListener('click', () => {
        settingsBtn.parentElement.classList.toggle('settings-open');
    });

    window.addEventListener('click', e => {
        if (!settingsBtn.parentElement.contains(e.target)) {
            settingsBtn.parentElement.classList.remove('settings-open');
        }
    });
}

function initProductDetail() {
    const container = document.querySelector('.product-detail');
    if (!container) {
        return;
    }

    initProductDetailHistory(container);
    initProductDetailAudio(container);

    for (const subContainer of container.querySelectorAll('.product-detail-subproducts')) {
        initProductDetailSubproducts(subContainer);
    }

    const mainSwiperContainer = container.querySelector('.product-detail-header-images-banner .swiper-container');
    const mainSlider = new Swiper(mainSwiperContainer, {
        loop: true,
        slidesPerView: 1,
        noSwiping: true,
        noSwipingClass: 'swiper-slide',
        navigation: {
            nextEl: mainSwiperContainer.parentElement.querySelector('.swiper-button-next'),
            prevEl: mainSwiperContainer.parentElement.querySelector('.swiper-button-prev')
        },
        grabCursor: true,
        spaceBetween: 16,
    });

    const gallery = document.querySelector('.product-detail-gallery');
    const galleryButtons = gallery.querySelectorAll('.product-detail-gallery-item');

    const isTouch = window.matchMedia('(pointer: coarse)').matches;

    let zoomist;
    let zoomistInitTimeout;
    let isZoomed = false;

    function updateZoomist(slide) {
        zoomist?.destroy(true);
        isZoomed = false;

        clearTimeout(zoomistInitTimeout);
        zoomistInitTimeout = setTimeout(() => {
            zoomist = new Zoomist(slide.querySelector('.zoomist-container'), {
                maxScale: 3,
                bounds: true,
            });

            zoomist.on('zoom', () => {
                isZoomed = true;
            });
        }, 400);
    }

    const gallerySwiperContainer = container.querySelector('.product-detail-gallery-main .swiper-container');
    const gallerySlider = new Swiper(gallerySwiperContainer, {
        loop: true,
        slidesPerView: 1,
        noSwiping: true,
        noSwipingClass: 'swiper-slide',
        navigation: {
            nextEl: gallerySwiperContainer.parentElement.querySelector('.swiper-button-next'),
            prevEl: gallerySwiperContainer.parentElement.querySelector('.swiper-button-prev')
        },
        spaceBetween: 16,
        on: {
            slideChange() {
                const activeSlide = this.slides[this.activeIndex];
                if (!activeSlide) {
                    return;
                }
                updateZoomist(activeSlide);
            }
        }
    });

    $(gallerySwiperContainer).on('click', '.swiper-slide', () => {
        if (!isZoomed) {
            zoomist.zoomTo(2);
        }
        isZoomed = true;
    });

    $(mainSwiperContainer).on('click', 'button', e => {
        gallery.showModal();
        gallerySlider.update();
        for (const button of galleryButtons) {
            button.classList.remove('product-detail-gallery-item-active');
        }
        gallerySlider.slideTo(parseInt(e.currentTarget.dataset.index));
        updateZoomist(gallerySlider.slides[gallerySlider.activeIndex]);
        galleryButtons[e.currentTarget.dataset.index]?.classList.add('product-detail-gallery-item-active');
    });

    $(mainSwiperContainer).on('pointermove', 'button', e => {
        if (isTouch) {
            return;
        }

        /** @type {PointerEvent} */
        const origEvent = e.originalEvent;

        const x = origEvent.offsetX;
        const y = origEvent.offsetY;
        const btn = e.currentTarget;
        const img = btn.firstElementChild;
        const {width, height} = btn.getBoundingClientRect();

        const xPercent = x / width * 100;
        const yPercent = y / height * 100;

        img.style.transform = `translate(${100 - xPercent}%, ${100 - yPercent}%) scale(2)`;
    });

    $(mainSwiperContainer).on('pointerleave', 'button', e => {
        if (isTouch) {
            return;
        }

        const img = e.currentTarget.firstElementChild;
        img.style.transform = null;
    });

    for (const button of galleryButtons) {
        button.addEventListener('click', () => {
            gallerySlider.slideTo(parseInt(button.dataset.index));

            for (const sibling of galleryButtons) {
                if (sibling === button) {
                    continue;
                }
                sibling.classList.remove('product-detail-gallery-item-active');
            }

            button.classList.add('product-detail-gallery-item-active');
        });
    }

    const closeButton = gallery.querySelector('.product-detail-gallery-close');
    closeButton.addEventListener('click', () => {
        gallery.close();
    });


    const imageContainer = container.querySelector('.product-detail-header-images');
    const subImages = imageContainer.querySelectorAll('.product-detail-header-images-item');
    const outerContainer = imageContainer.querySelector('.product-detail-header-images-items-outer');
    const expandButton = imageContainer.querySelector('.product-detail-header-images-expand');

    for (let i = 0; i < subImages.length; i++) {
        const image = subImages[i];
        image.addEventListener('click', () => {
            mainSlider.slideTo(i);
        });
    }


    function updateMainImageWidth() {
        //mainImage.style.height = `${mainImage.parentElement.clientWidth}px`;

        let expandable = false;
        for (const image of subImages) {
            if (image.offsetTop > 0) {
                expandable = true;
                break;
            }
        }

        outerContainer?.classList.toggle('expandable', expandable);

        if (expandButton) {
            requestAnimationFrame(() => {
                let hiddenItems = 0;
                for (const image of subImages) {
                    if (image.offsetTop > 0) {
                        hiddenItems++;
                    }
                }

                expandButton.querySelector('span').innerText = `+${hiddenItems}`;
            });
        }
    }

    window.addEventListener('resize', updateMainImageWidth);
    updateMainImageWidth();

    expandButton?.addEventListener('click', () => {
        outerContainer.classList.toggle('expanded');
    });
}

function initProductDetailHistory(container) {
    const categoryId = parseInt(container.dataset.category);

    const rawState = sessionStorage.getItem('detailState') ?? '{"category": 0, "path": []}';
    const state = JSON.parse(rawState);

    if (categoryId === state.category) {
        if (state.path[state.path.length - 1] !== location.pathname) {
            state.path.push(location.pathname);
        }
    } else {
        state.category = categoryId;
        state.path = [location.pathname];
    }

    sessionStorage.setItem('detailState', JSON.stringify(state));
    const buttons = container.querySelector('.product-detail-filter-buttons');
    if (!buttons) {
        return;
    }
    const backButton = buttons.querySelector('.product-detail-filter-button-back');
    const resetButton = buttons.querySelector('.product-detail-filter-button-reset');

    buttons.classList.toggle('product-detail-filter-buttons-active', state.path.length > 1);

    backButton.addEventListener('click', () => {
        state.path.pop();
        sessionStorage.setItem('detailState', JSON.stringify(state));
        history.back();
    });

    resetButton.addEventListener('click', () => {
        const firstLocation = state.path[0];
        state.path = [firstLocation];
        sessionStorage.setItem('detailState', JSON.stringify(state));
        location.pathname = firstLocation;
    });
}

/**
 * Initializes the audio player for product detail media.
 *
 * @param {HTMLElement} rootContainer The root container element that contains the audio player.
 */
function initProductDetailAudio(rootContainer) {
    for (const container of rootContainer.querySelectorAll('.product-detail-media-sound')) {
        const playButton = container.querySelector('[data-action="play"]');
        const rewindButton = container.querySelector('[data-action="rewind"]');
        const endButton = container.querySelector('[data-action="end"]');
        const audioElement = container.querySelector('audio');
        /** @type {HTMLDivElement} */
        const trackElement = container.querySelector('.product-detail-media-sound-progress-track-wrap');

        let playing = false;

        function _uploadPlayState(play) {
            if (play) {
                audioElement.play()
                    .then(() => {
                        container.classList.add('playing');
                    })
                    .catch(console.log);
            } else {
                audioElement.pause();
                container.classList.remove('playing');
            }
        }

        audioElement.addEventListener('timeupdate', () => {
            container.style.setProperty('--progress', `${audioElement.currentTime / audioElement.duration * 100}%`);
        });

        audioElement.addEventListener('ended', () => {
            playing = false;
            _uploadPlayState(playing);
        });

        audioElement.addEventListener('pause', () => {
            playing = false;
            _uploadPlayState(playing);
        });

        audioElement.addEventListener('play', () => {
            playing = true;
            _uploadPlayState(playing);

            for (const audioEl of document.querySelectorAll('audio')) {
                if (audioEl !== audioElement) {
                    audioEl.pause();
                }
            }
        });

        playButton.addEventListener('click', () => {
            playing = !playing;
            _uploadPlayState(playing);
        });

        rewindButton.addEventListener('click', () => {
            audioElement.currentTime = 0;
            playing = false;
            _uploadPlayState(playing);
        });

        endButton.addEventListener('click', () => {
            audioElement.currentTime = audioElement.duration;
            playing = false;
            _uploadPlayState(playing);
        });

        let dragging = false;
        let screenStartX = 0;
        let trackStartX = 0;

        trackElement.addEventListener('pointerdown', e => {
            playing = false;
            _uploadPlayState(playing);
            audioElement.currentTime = audioElement.duration * (e.offsetX / trackElement.clientWidth);
            screenStartX = e.screenX;
            trackStartX = e.offsetX;
            dragging = true;
        });

        window.addEventListener('pointerup', () => {
            dragging = false;
        });

        window.addEventListener('pointermove', e => {
            if (!dragging) {
                return;
            }

            const currentX = e.screenX;
            const offset = currentX - screenStartX;

            const relativeTrackPos = Math.max(0, Math.min(trackElement.clientWidth, trackStartX + offset));

            audioElement.currentTime = audioElement.duration * (relativeTrackPos / trackElement.clientWidth);
        });
    }
}

/**
 *
 * @param {HTMLDivElement} container
 */
function initProductDetailSubproducts(container) {
    new Swiper(container.querySelector('.swiper-container'), {
        slidesPerView: 2,
        spaceBetween: 24,
        grabCursor: true,
        navigation: {
            nextEl: container.querySelector('.swiper-button-next'),
            prevEl: container.querySelector('.swiper-button-prev')
        },
        breakpoints: {
            990: {
                slidesPerView: 4
            },
            600: {
                slidesPerView: 3
            }
        }
    });
}

function initProductFilters() {
    /** @type {NodeListOf<HTMLFormElement>} */
    const filters = document.querySelectorAll('.product-list-filter');
    for (const filter of filters) {

        const slidesContainer = filter.nextElementSibling;
        const slides = slidesContainer.querySelectorAll('.swiper-slide');

        /** @type {WeakMap<HTMLDivElement, {filterPreviews: {key: string, link: string, image: string}[], selectedProduct: {link: string, image: string}}>} */
        const slidesData = new WeakMap();
        for (const slide of slides) {
            slidesData.set(slide, {
                filterPreviews: JSON.parse(slide.dataset.filterPreviews),
                selectedProduct: JSON.parse(slide.dataset.selectedProduct)
            });
        }

        filter.addEventListener('submit', e => {
            e.preventDefault();
            _doFilter();
        });

        filter.addEventListener('reset', () => {
            setTimeout(_doFilter);
        });

        function _doFilter() {
            const data = new FormData(filter);

            const lookupKeys = Array.from(data.entries())
                .filter(([_, value]) => !!value)
                .map(([key, value]) => `${key}:${value}`);

            for (const slide of slides) {
                const mappedData = slidesData.get(slide);

                if (lookupKeys.length === 0) {
                    _updateSlide(slide, mappedData.selectedProduct);
                    slide.hidden = false;
                    continue;
                }

                let found = false;
                for (const entry of mappedData.filterPreviews) {
                    const allIncluded = lookupKeys.every(k => entry.key.includes(k));

                    if (!allIncluded) {
                        continue;
                    }
                    _updateSlide(slide, entry);

                    found = true;
                    break;
                }

                slide.hidden = !found;
            }

            slidesContainer.querySelector('.swiper-container').swiper.updateSlides();
        }

        function _updateSlide(slide, slideData) {
            for (const a of slide.querySelectorAll('a')) {
                a.href = slideData.link;
            }

            slide.querySelector('img').src = slideData.image;
        }

    }
}

function initFaq() {
    const elements = document.querySelectorAll('.faq-list');
    for (const element of elements) {

        /** @type {HTMLDivElement} */
        const sidebar = element.querySelector('.faq-list-sidebar');

        /** @type {HTMLButtonElement} */
        const expandButton = sidebar.querySelector('.faq-list-sidebar-expand');

        expandButton.addEventListener('click', () => {
            sidebar.classList.toggle('faq-list-sidebar--open');
        });
    }
}

function initNavLinks() {
    window.addEventListener('hashchange', () => {
        document.body.classList.remove('nav-open');
        document.querySelector('.header-wrap').classList.remove('nav-open');
        for (const item of document.querySelectorAll('.menu-link.clicked')) {
            item.classList.remove('clicked');
        }
    });
}

function initSerialForm() {
    /** @type {HTMLDivElement} */
    const container = document.querySelector('.check-serial');
    if (!container) {
        return;
    }

    const result = container.querySelector('.check-serial-result');

    /** @type {HTMLFormElement} */
    const form = container.querySelector('form');

    const translations = JSON.parse(form.dataset.translations);

    form.addEventListener('submit', e => {
        e.preventDefault();

        const data = new FormData(form);
        /** @type {string} */
        const serial = data.get('serial');
        const language = form.dataset.language;

        const url = new URL('/fileadmin/api/checkSerialV2/', location);
        url.searchParams.set('lang', language);
        url.searchParams.set('serial', serial);

        result.classList.add('show');
        result.innerHTML = 'Loading...';

        fetch(url)
            .then(res => res.json())
            .then(res => {
                if (res.error) {
                    result.innerHTML = `
                        <div class="error">
                            <p>${translations.serialNotFound}: <span class="error-serial">${serial}</span></p>
                        </div>
                    `;
                    return;
                }

                const tables = res.map((entry, idx) => {
                    const rows = [];

                    rows.push(...[
                        `
                            <tr style="display: table-row !important;">
                                <td class="label">${translations.serialNumber}</td>
                                <td>${entry.serialNumber}</td>
                            </tr>
                        `,
                        `
                            <tr style="display: table-row !important;">
                                <td class="label">${translations.articleNumber}</td>
                                <td>${entry.articleNumber}</td>
                            </tr>
                        `
                    ]);

                    for (const value of Object.values(entry.attributes)) {
                        rows.push(`
                            <tr style="display: table-row !important;">
                                <td class="label">${value.label}</td>
                                <td>${value.value}</td>
                            </tr>
                        `);
                    }

                    const downloadUrl = new URL(url);
                    downloadUrl.searchParams.set('download', idx);

                    return `
                        <div class="check-serial-table">
                            <table>
                                ${rows.join('')}
                            </table>
                            <a class="check-serial-download link-button" target="_blank" href="${downloadUrl}">
                                ${translations.downloadPdf}
                            </a>
                        </div>
                    `;
                });

                result.innerHTML = tables.join('');
            });
    });
}
